import React from "react";
import { TextField, InputAdornment, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SearchNormal1 } from "iconsax-react";
import { RADIUS } from "../../theme/mixins";

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  width?: string | number;
  variant?: "outlined" | "filled" | "standard";
  size?: "small" | "medium";
}

const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  placeholder,
  width = 400,
  variant = "outlined",
  size = "medium",
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <TextField
      variant={variant}
      size={size}
      placeholder={placeholder ?? t("components.searchBar.placeholder")}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchNormal1 size={24} variant="Outline" color={theme.palette.text.secondary} />
          </InputAdornment>
        ),
      }}
      sx={(theme) => ({
        width,
        "& .MuiOutlinedInput-root": {
          height: 54,          
          borderRadius: `${RADIUS.input}px`,
          backgroundColor: theme.palette.common.white,
          fontSize: "14px",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.border.strong,
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.border.grey,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.primary.main,
            borderWidth: "1px",
          },
        },
        "& .MuiInputBase-input": {
          padding: "0 14px",
          fontSize: "0.875rem",
          fontWeight: 400,
          lineHeight: "22px",
          color: theme.palette.text.primary,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          "&::placeholder": {
            color: theme.palette.text.disabled,
            opacity: 1,
          },
        },
      })}
    />
  );
};

export default SearchBar;
